module.exports = __webpack_public_path__ + "static/media/stop-8.0058d367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-8.svg
// module id = 1375
// module chunks = 0